import Splide from '@splidejs/splide';

if ($('.gallery').length) {
  const windowWidth = window.innerWidth;
  const dots = new Splide( '#gallery-dots', {
    isNavigation: true,
    start: 0,
    pagination: false,
    arrows: false,
    focus: 'center',
    slideFocus: true,
    perMove: 1,
  });

  const contentSlider = new Splide( '#gallery', {
    start: 0,
    pagination: false,
    arrows: false,
    drag: "free",
    autoWidth: true,
    speed: 1000,
    breakpoints : {
      1024: {
        dragMinThreshold: 0.1,
        drag: true,
        focus: 'center',
        slideFocus: true,
        perMove: 1,
        speed: 700,
        useScroll: true,
        easing: 'cubic-bezier(0, 1.4, .17, 1.4)',
      }
    },
  });

  const mobileDots = new Splide( '#mobile-gallery-dots', {
    isNavigation: true,
    start: 0,
    pagination: false,
    arrows: false,
    focus: "center",
    slideFocus: true,
    perMove: 1,
  });

  if ( windowWidth > 1024 ) {

    dots.mount();
    contentSlider.sync(dots).mount();

    const imagesArray = $('.gallery-item');
    const galleryDots = $('.gallery-dots').find('.splide__slide');

    const dotsClassHandler = (dotIndex) => {
      galleryDots.removeClass('is-active', 'is-next', 'is-prev');
      $(galleryDots[dotIndex]).addClass('is-active');
      $(galleryDots[dotIndex - 1]).addClass('is-prev');
      $(galleryDots[dotIndex + 1]).addClass('is-next');
    }

    contentSlider.on('scrolled', function() {
      if (imagesArray.index($(".gallery-item.is-active.is-visible")) > -1) {
        const dotIndex = imagesArray.index($(".gallery-item.is-active.is-visible"));
        dotsClassHandler(dotIndex);
      } else if (imagesArray.index($(".gallery-item.is-visible")) > -1) {
        const dotIndex = imagesArray.index($(".gallery-item.is-visible"));
        dotsClassHandler(dotIndex);
      }
    })
  } else {

    mobileDots.mount();
    contentSlider.sync(mobileDots).mount();
  }
}
